export default __webpack_public_path__ + "static/media/bell.7e3c1db8.svg";